import SimplifiedRequest from './SimplifiedRequest'
import Detail from './SimplifiedRequestDetail'

export default (dispatcher, store) => ({
    path:'/simplifiedrequests',
    indexRoute: {
        component: SimplifiedRequest
    },
    childRoutes: [{
        path: ':id',
        component: Detail,
    }]
})



// WEBPACK FOOTER //
// ./lib/simplifiedRequest/routes.js